(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sections-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.missPepSectionRevealLoaded) return;
    window.missPepSectionRevealLoaded = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sectionSelector = '#MainContent > .shopify-section, main > .shopify-section';
    const excludedSelector = '.section-miss-pep-hero';

    const observer = reduceMotion
      ? null
      : new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        });

    const prepareSection = (section) => {
      if (!(section instanceof HTMLElement)) return;

      if (
        section.matches(excludedSelector) ||
        section.classList.contains('msr-reveal')
      ) {
        return;
      }

      section.classList.add('msr-reveal');

      if (reduceMotion) {
        section.classList.add('is-visible');
        return;
      }

      observer.observe(section);
    };

    document.documentElement.classList.add('msr-ready');
    document.querySelectorAll(sectionSelector).forEach(prepareSection);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('.shopify-section')
        ? event.target
        : event.target.closest('.shopify-section');

      prepareSection(section);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
